// import external dependencies
import "jquery";

// Import everything from autoload
import "./autoload/_bootstrap.js";

//Import axios
import "axios/dist/axios.min";
//Import qs stringify
import "qs/dist/qs";
// Import Slick Slider
import "slick-carousel/slick/slick.min";
// Masonary
import "masonry-layout/dist/masonry.pkgd.min";
// Lazy laod
import "jquery-lazy/jquery.lazy.min";
// Select 2
import "select2/dist/js/select2";
// Custom Event polyfill
import "custom-event-polyfill/polyfill";

// import local dependencies
import Router from "./util/Router";
import common from "./routes/common";
import home from "./routes/home";
import aboutUs from "./routes/about";
import templateProducts from "./routes/products";
import singleProduct from "./routes/single-product";
import productTemplateTemplateFusionframe from "./routes/fusionframe";
import templateNews from "./routes/news";
import templateIfu from "./routes/ifu";
import contact from "./routes/contact";
import templateCleanStart from "./routes/cleanstart";

/** Populate Router instance with DOM routes */
const routes = new Router({
  // All pages
  common,
  // Home page
  home,
  // About Us page, note the change from about-us to aboutUs.
  aboutUs,
  // Products page
  templateProducts,
  // News Page
  templateNews,
  // IFU page
  templateIfu,
  // Fusion Frame page
  productTemplateTemplateFusionframe,
  // Single product
  singleProduct,
  //Contact
  contact,
  //CleanStart
  templateCleanStart,
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());



// WEBPACK FOOTER //
// ./scripts/main.js